import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Subsection from "components/Subsection";
import Table from "components/Table";
import { budgetBuilderSelectors, tenantSelectors } from "store/selectors";
import {
	getLineItemsDirectCostTotal,
	getNonSubawardLineItemsFACostTotal,
	getPeriodSubtotal,
	getRateSubtotal,
	getSubawardsFACostTotalForPeriod,
} from "utils/budgetBuilder";

import styles from "./styles.css";


const SummaryList = () => {
	const { currencyFormatter } = useTenantFormatter();
	const members = useSelector(budgetBuilderSelectors.researchTeamMembers);
	const sponsoredCosts = useSelector(budgetBuilderSelectors.sponsoredCosts);
	const faRateAmount = useSelector(budgetBuilderSelectors.currentPeriodRate) || 0;
	const hasFringeRate = useSelector(budgetBuilderSelectors.hasFringeRate(false));
	const hasSalaryRate = useSelector(budgetBuilderSelectors.hasSalaryRate(false));
	const sponsoredCostsByPeriod = useSelector(budgetBuilderSelectors.sponsoredCostsByPeriod);
	const { subawardCostCap } = useSelector(tenantSelectors.tenant);

	const researchTeamSubtotal = useMemo(
		() => getPeriodSubtotal(members, false),
		[ members ],
	);

	const currentPeriodNumber = useSelector(budgetBuilderSelectors.currentPeriodNumber);

	const lineItemsFASubtotal = useMemo(
		() => {
			const nonSubawardTotal = getNonSubawardLineItemsFACostTotal(sponsoredCosts, faRateAmount);
			let subawardTotal = getSubawardsFACostTotalForPeriod(
				sponsoredCostsByPeriod,
				subawardCostCap,
				currentPeriodNumber,
			);

			return nonSubawardTotal + subawardTotal;
		},
		[ sponsoredCosts, faRateAmount, sponsoredCostsByPeriod, subawardCostCap, currentPeriodNumber ]
	);
	const lineItemsSubtotal = useMemo(
		() => getLineItemsDirectCostTotal(sponsoredCosts),
		[ sponsoredCosts ],
	);

	const researchTeamFASubtotal = useMemo(
		() => getRateSubtotal(faRateAmount, members, hasFringeRate, hasSalaryRate, false),
		[ faRateAmount, members, hasFringeRate, hasSalaryRate ],
	);

	const sponsorCostsTotal = researchTeamSubtotal + researchTeamFASubtotal + lineItemsSubtotal + lineItemsFASubtotal;

	return (

		<Subsection
			title={"Sponsor Cost Total"}
		>
			<Table captionText="Sponsor Cost Summary">
				{/* todo - convert this to a map */}
				<Table.Body>
					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Research Team Salary and Fringe Subtotal"}</span>
						</Table.Cell>
						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(researchTeamSubtotal)}</span>
						</Table.Cell>
					</Table.Row>
					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Research Team F&A Subtotal"}</span>
						</Table.Cell>
						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(researchTeamFASubtotal)}</span>
						</Table.Cell>
					</Table.Row>
					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Line Items Subtotal"}</span>
						</Table.Cell>
						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(lineItemsSubtotal)}</span>
						</Table.Cell>
					</Table.Row>
					<Table.Row className={styles.rowHeader}>
						<Table.Cell width="nine">
							<span className={styles.bold}>{"Line Items F&A Subtotal"}</span>
						</Table.Cell>
						<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`} width="two">
							<span>{currencyFormatter(lineItemsFASubtotal)}</span>
						</Table.Cell>
					</Table.Row>
					<Table.Row className={styles.rowHeader}>
						<Table.Cell className={styles.rowHeaderCell} width="nine">
							<span className={styles.bold}>{"Sponsor Costs Total"}</span>
						</Table.Cell>
						<Table.Cell
							className={`${styles.rowHeaderCell} ${styles.cellAlignRight} ${styles.valueCellPadding}`}
							width="two"
						>
							<span>{currencyFormatter(sponsorCostsTotal)}</span>
						</Table.Cell>
					</Table.Row>
				</Table.Body>
			</Table>

		</Subsection>

	);
};

export default SummaryList;
